<template>
  <layout>
    <div class="w-full flex flex-col adm-container">
      <pt-view-table
        :data="list"
        :columns="tableColumns"
        class="w-full mb-8" />
      <pt-pagination
        :total-rows="totalRows"
        :current-page="currentPage"
        :page-size="pageSize"
        @page-changed="fetchActivityList" />
    </div>
  </layout>
</template>

<script>
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import Layout from '@layouts/main';
import makeRequest from '../../../utils/apiRequest';
import Config from '../../../config';

const DEFAULT_CURRENT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export default {
  name: 'ActivityLogList',
  page: {
    title: 'Activity Log',
  },
  components: { Layout, PtViewTable, PtPagination, makeRequest, Config },
  data() {
    return {
      list: [],
      tableColumns: [{
        header: 'Time',
        accessor: 'created_at',
      }, {
        header: 'Description',
        accessor: 'description',
      }, {
        header: 'Subject',
        accessor: 'subject_type',
      }, {
        header: 'Causer',
        accessor: 'causer_type',
      }],
      totalRows: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.fetchPartnerList();
  },
  methods: {
    fetchPartnerList(currentPage = DEFAULT_CURRENT_PAGE, pageSize = DEFAULT_PAGE_SIZE) {
      const pageParams = `page=${currentPage}&perPage=${pageSize}`;
      const logMeta = {
        url: `${Config.api.baseURL}api/activities/list?${pageParams}`,
      };

      makeRequest(logMeta)
        .then((response) => {
          this.list = response.data.data;
          this.totalRows = response.data.meta.pagination.total;
          this.currentPage = response.data.meta.pagination['current_page'];
          this.pageSize = response.data.meta.pagination['per_page'];
        })
        .catch((errorResponse) => {
          this.$notification.error('Error fetching activity list');
          console.error(errorResponse);
        });
    },
  },
};
</script>
